import { useRef } from "react";
import { EDITORIAL } from "../data/content";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const slugify = (t) => t.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const BookHeader = ({ item, slug }) => (
    <div className="flex items-baseline justify-between gap-4 border-b border-[var(--line)] pb-4 mb-6 md:mb-8">
        <div className="flex items-baseline gap-3 md:gap-5 min-w-0">
            <span className="font-mono2 text-[10px] md:text-xs text-[var(--red)]">{item.id}</span>
            <h3 className="font-display text-lg sm:text-2xl md:text-4xl uppercase tracking-tight truncate" data-testid={`editorial-title-${slug}`}>
                {item.title}
            </h3>
        </div>
        <span className="font-mono2 text-[9px] md:text-[10px] tracking-[0.2em] text-[var(--mute)] uppercase whitespace-nowrap">
            {item.meta}
        </span>
    </div>
);

const BookStage = ({ item, slug }) => {
    const videoRef = useRef(null);
    const spin = () => videoRef.current?.play().catch(() => {});
    const rest = () => videoRef.current?.pause();

    return (
        <figure className="group relative" data-cursor="SPIN" onMouseEnter={spin} onMouseLeave={rest} onTouchStart={spin}>
            <div className="overflow-hidden aspect-[16/7] md:aspect-[16/6]">
                <video
                    ref={videoRef}
                    src={item.video}
                    poster={item.poster}
                    muted
                    loop
                    playsInline
                    preload="auto"
                    className="w-full h-full object-cover object-center brightness-[0.9] contrast-[1.4]"
                    aria-label={item.alt}
                    data-testid={`editorial-video-${slug}`}
                />
            </div>
            <span className="pointer-events-none absolute bottom-4 left-4 font-mono2 text-[9px] tracking-[0.25em] uppercase text-[var(--mute)] opacity-100 group-hover:opacity-0 transition-opacity duration-300">
                Hover to spin
            </span>
        </figure>
    );
};

const Book = ({ item, delay = 0 }) => {
    const slug = slugify(item.title);
    return (
        <Reveal delay={delay}>
            <div data-testid={`editorial-item-${slug}`}>
                <BookHeader item={item} slug={slug} />
                <BookStage item={item} slug={slug} />
            </div>
        </Reveal>
    );
};

export const Editorial = () => (
    <section className="pt-28 md:pt-44" data-testid="editorial-section">
        <SectionHeading index="02" title="Editorial design" id="editorial" />
        <div className="px-6 md:px-12 flex flex-col gap-12 md:gap-16">
            {EDITORIAL.map((item, i) => (
                <Book key={item.id} item={item} delay={i * 0.12} />
            ))}
        </div>
    </section>
);
